import { useState, useEffect } from 'react';
import { getCodes, getModifs, insertTransac, getUser } from '../API';
import QuickAccess from '../components/QuickAccess';
import CodeAccess from '../components/CodeAccess';
import TypeAccess from '../components/TypeAccess';

const Transaction = () => {

  const [codes, setCodes] = useState(null);
  const [qteQuick, setQteQuick] = useState(1);
  const [qteCode, setQteCode] = useState(1);
  const [qteType, setQteType] = useState(1);

  const [goodShortcut, setGoodShortcut] = useState(null);
  const [goodCode, setGoodCode] = useState(null);
  const [shortcutDesc, setShortcutDesc] = useState('');
  const [shortcutCat, setShortcutCat] = useState('');
  const [shortcutSouscat, setShortcutSouscat] = useState('');
  const [shortcutCode, setShortcutCode] = useState('');
  const [shortcutValeur, setShortcutValeur] = useState('');
  const [codeDesc, setCodeDesc] = useState('');
  const [codeCat, setCodeCat] = useState('');
  const [codeSouscat, setCodeSouscat] = useState('');
  const [codeCode, setCodeCode] = useState('');
  const [codeValeur, setCodeValeur] = useState('');
  const [modificateurs, setModificateurs] = useState('');
  const [modifSelect, setModifSelect] = useState(null);
  const [modifValSelect, setModifValSelect] = useState(null);
  const [modifobject, setModifObject] = useState([]);
  const [allcat, setAllcat] = useState([]);
  const [catSelect, setCatSelect] = useState('');
  const [souscatSelect, setSouscatSelect] = useState(null);
  const [descSelect, setDescSelect] = useState(null);
  const [souscatValue, setSouscatValue] = useState(null);
  const [user, setUser] = useState({});
  const [refreshKey, setRefreshKey] = useState(0);
  const [saveSuccessForm, setSaveSuccessForm] = useState(null);

  const saveTransaction = async (transaction, formId) => {
    const response = await insertTransac(transaction);
    if (response.ok) {
      setSaveSuccessForm(formId);
      setTimeout(() => setSaveSuccessForm(null), 3000);
    }
  };

  useEffect(() => {

    getUser().then(response => {
      if (response != null && response.profileid) {
        setUser(response);

        getCodes().then(codes => {
          setCodes(codes);
          getModifs().then(modifs => {
            setModifObject(modifs);
            setModificateurs([...new Set(modifs.map((e) => { return e.mod }))]);
            setAllcat([...new Set(codes.map((e) => { return e.cat; }))])
          })
        })
      }
    })

  }, [refreshKey])


  const handleSelectCat = (e) => {
    const selectedCat = e.target.value;
    handleCatChanged(selectedCat);
  };

  const handleCatChanged = (selectedCat) => {
    const codesSouscat = codes.filter((e) => {
      return e.cat === selectedCat;
    });
    const selectedSouscat = [
      ...new Set(
        codesSouscat.map((e) => {
          return e.souscat;
        })
      )
    ];
    selectedSouscat.unshift('--Choisir sous-catégorie');
    setCatSelect(selectedCat);
    setSouscatSelect(selectedSouscat)
    setRefreshKey(oldKey => oldKey + 1);
  };

  const handleSelectSouscat = (e) => {
    const selectedSouscat = e.target.value;
    handleSouscatChanged(selectedSouscat);
  };

  const handleSouscatChanged = (selectedSouscat) => {
    const codesDesc = codes.filter((e) => {
      return e.souscat === selectedSouscat;
    });
    const selectedDesc = [
      ...new Set(
        codesDesc.map((e) => {
          return e.description + ' [' + e.code + '] ' + e.val;
        })
      )
    ];
    setDescSelect(selectedDesc);
    setRefreshKey(oldKey => oldKey + 1);
  };

  const handleQteType = (e) => {
    setQteType(e.target.value)
  }

  const formCompleteSubmitted = (event) => {
    event.preventDefault();
    if (event.target.inputDesc.value.substr(0, 2) !== '--') {
      let myRegex = /(\d{5})/;
      let selectCode = myRegex.exec(event.target.inputDesc.value)[0];
      let split = event.target.inputDesc.value.split(' ');
      let valeur = parseFloat(split[split.length - 1]);
      let descArr = [];
      for (let i = 0; i < split.length - 2; i++) {
        descArr.push(split[i]);
      }
      let descrip = descArr.join(' ');

      const transaction = {
        cat: event.target.inputCat.value,
        souscat: event.target.inputSouscat.value,
        description: descrip,
        code: selectCode,
        val: valeur,
        qte: event.target.inputQte.value,
        notes: event.target.inputNotes.value
      };

      if (event.target.inputQte.value >= 0) {
        saveTransaction(transaction, 'type');
        event.currentTarget.elements.inputNotes.value = '';
        setCatSelect('');
        setSouscatSelect('');
        setDescSelect('');
        setRefreshKey(oldKey => oldKey + 1);
      }
    }
  };

  const handleQteQuick = (e) => {
    setQteQuick(e.target.value)
  }

  const handleShortcutChange = (e) => {
    if (!e.target.value.trim()) {
      setGoodShortcut(null);
      return;
    }

    if (codes.filter((i) => i.quickaccess === e.target.value).length > 0) {
      const codeChoisi = codes.filter((i) => i.quickaccess === e.target.value);
      setGoodShortcut(1);
      setShortcutDesc(codeChoisi[0].description);
      setShortcutCat(codeChoisi[0].cat);
      setShortcutSouscat(codeChoisi[0].souscat);
      setShortcutCode(codeChoisi[0].code);
      setShortcutValeur(codeChoisi[0].val)
    } else {
      setGoodShortcut(0);
    }
  };

  const formQuickCompleteSubmitted = (event) => {
    event.preventDefault();
    if (goodShortcut === 1) {
      const transaction = {
        cat: shortcutCat,
        souscat: shortcutSouscat,
        description: shortcutDesc,
        code: shortcutCode,
        val: shortcutValeur,
        qte: event.target.inputShortcutQte.value,
        notes: event.target.inputShortcutNotes.value
      };

      if (goodShortcut === 1 && event.target.inputShortcutQte.value > 0) {
        saveTransaction(transaction, 'quick');
        event.target.elements.inputShortcut.value = '';
        event.target.elements.inputShortcutNotes.value = '';
      }

      setGoodShortcut(null);
      setRefreshKey(oldKey => oldKey + 1);
    }
  }

  const handleQteCode = (e) => {
    setQteCode(e.target.value)
  }

  const handleSelectModif = (e) => {
    const selectedModif = parseFloat(e.target.value);
    const modifVal = modifobject.filter((e) => {
      return e.mod === selectedModif;
    });
    const modifValSelect = modifVal[0].facteur;

    setModifSelect(selectedModif);
    setModifValSelect(modifValSelect);
    setRefreshKey(oldKey => oldKey + 1);

  }

  const handleCodeChange = (e) => {
    if (!e.target.value.trim()) {
      setGoodCode(null);
      return;
    }

    if (codes.filter((i) => i.code === parseInt(e.target.value)).length > 0) {
      const codeChoisi = codes.filter((i) => i.code === parseInt(e.target.value));
      setGoodCode(1);
      setCodeDesc(codeChoisi[0].description);
      setCodeCat(codeChoisi[0].cat);
      setCodeSouscat(codeChoisi[0].souscat);
      setCodeCode(codeChoisi[0].code);
      setCodeValeur(codeChoisi[0].val)

    } else {
      setGoodCode(0);

    }
  };

  const formCodeCompleteSubmitted = (event) => {
    event.preventDefault();

    if (event.target.inputCodeQte.value > 0) {
      setQteCode(event.target.inputCodeQte.value)
    }

    if (goodCode === 1 && qteCode > 0) {
      const transaction = {
        cat: codeCat,
        souscat: codeSouscat,
        description: codeDesc,
        code: codeCode,
        val: codeValeur,
        qte: event.target.inputCodeQte.value,
        notes: event.target.inputCodeNotes.value,
        modificateur: modifSelect,
        modifval: modifValSelect
      };

      if (goodCode === 1 && qteCode > 0) {
        saveTransaction(transaction, 'code');
        event.target.elements.inputCode.value = '';
        event.currentTarget.elements.inputCodeNotes.value = '';
        setModifSelect(null);
        setModifValSelect(null);
        setGoodCode(null);
        setRefreshKey(oldKey => oldKey + 1);
      }
    }
  }

  const pageHeader = (
    <header className="dashboard-page-header">
      <p className="page-eyebrow">Saisie</p>
      <h1>Transaction</h1>
      <p className="page-lead">
        Enregistrez une activité par raccourci, par code ou par catégorie.
      </p>
    </header>
  );

  return codes !== null && modificateurs !== '' ? (
    <div className="container transaction-page">
      {pageHeader}

      <div className="transaction-form-grid">
        <QuickAccess
          formQuickCompleteSubmitted={formQuickCompleteSubmitted}
          goodShortcut={goodShortcut}
          handleShortcutChange={handleShortcutChange}
          shortcutDesc={shortcutDesc}
          qteQuick={qteQuick}
          handleQteQuick={handleQteQuick}
          saveSuccess={saveSuccessForm === 'quick'}
        />
        <CodeAccess
          formCodeCompleteSubmitted={formCodeCompleteSubmitted}
          goodCode={goodCode}
          handleCodeChange={handleCodeChange}
          codeDesc={codeDesc}
          qteCode={qteCode}
          handleQteCode={handleQteCode}
          handleSelectModif={handleSelectModif}
          modifSelect={modifSelect}
          allMod={modificateurs}
          saveSuccess={saveSuccessForm === 'code'}
        />
      </div>

      <TypeAccess
        formCompleteSubmitted={formCompleteSubmitted}
        handleSelectCat={handleSelectCat}
        catSelect={catSelect}
        allcat={allcat}
        handleSelectSouscat={handleSelectSouscat}
        souscatValue={souscatValue}
        souscatSelect={souscatSelect}
        descSelect={descSelect}
        qteType={qteType}
        handleQteType={handleQteType}
        saveSuccess={saveSuccessForm === 'type'}
      />
    </div>
  ) : (
    <div className="container transaction-page">
      {pageHeader}
      <p className="dashboard-loading transaction-loading">Chargement...</p>
    </div>
  );
}

export default Transaction;
